import { connect } from "react-redux";

import ScreenCardCommentsBadge from "./ScreenCardCommentsBadge";
import { mapDispatchToProps, mapStateToProps } from "./ScreenCardCommentsBadgeMapper";

export default connect(mapStateToProps, mapDispatchToProps)(ScreenCardCommentsBadge);
